export function detectBrowserTimezone(): string | null {
  try {
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone?.trim();
    return timezone && isValidIanaTimezone(timezone) ? timezone : null;
  } catch {
    return null;
  }
}

export function isValidIanaTimezone(value: string): boolean {
  const timezone = value.trim();
  if (!timezone) return false;
  try {
    Intl.DateTimeFormat(undefined, { timeZone: timezone });
    return true;
  } catch {
    return false;
  }
}

export function areEquivalentTimezones(left: string, right: string): boolean {
  try {
    const knownAliases: Record<string, string> = {
      'asia/calcutta': 'asia/kolkata',
      'etc/utc': 'utc',
      'etc/gmt': 'utc',
    };
    const canonicalize = (timezone: string) => {
      const resolved = new Intl.DateTimeFormat('en', { timeZone: timezone })
        .resolvedOptions()
        .timeZone.toLowerCase();
      return knownAliases[resolved] ?? resolved;
    };
    return canonicalize(left) === canonicalize(right);
  } catch {
    return false;
  }
}

export function resolveInitialTimezone(
  persistedTimezone: string | null | undefined,
  browserTimezone: string | null,
  timezoneSource?: 'system' | 'user'
): string {
  const persisted = persistedTimezone?.trim();
  if (
    timezoneSource !== 'system' &&
    persisted &&
    isValidIanaTimezone(persisted)
  ) {
    return persisted;
  }
  if (browserTimezone && isValidIanaTimezone(browserTimezone)) {
    return browserTimezone;
  }
  return 'UTC';
}
